module.exports = __webpack_public_path__ + "img/content-bg.78be322c.png";